module.exports = __webpack_public_path__ + "img/404.74e85d76.svg";